/**
* @ngdoc service
* @name sharebase.sbFolderDetailService
* @requires $http
* @requires settingService
* @requires sbFolderService
* @description
* A service used to retrieve and interrogate ShareBase folder details.
**/
export function FolderDetailServiceFactory(
	$http:ng.IHttpService, 
	$q:ng.IQService, 
	settingsService, 
	sbFolderService
) {
	return {
		/**
		* @ngdoc method
		* @name sbFolderDetailService#getFolderDetails
		* @methodOf sharebase.sbFolderDetailService
		* @kind function
		*
		* @description
		* Retrieves a specific folder's details for the user.
		* 
		* @param {object} folder A folder object.
		*
		* @returns {Deferred} A promise that will resolve with a folder's details
		* 
		*/
		getFolderDetails,
		/**
		* @ngdoc method
		* @name sbFolderDetailService#getFolderShares
		* @methodOf sharebase.sbFolderDetailService
		* @kind function
		*
		* @description
		* Retrieves a specific folder's shares-by-link.
		* 
		* @param {object} folder A folder resource.
		*
		* @returns {Deferred} A promise that will resolve with an array the folder's shares-by-link.
		* 
		*/
		getFolderShares,
		/**
		* @ngdoc method
		* @name sbFolderDetailService#getFolderActivities
		* @methodOf sharebase.sbFolderDetailService
		* @kind function
		*
		* @description
		* Retrieves a specific folder's activities.
		* 
		* @param {object} folder A folder resource.
		*
		* @returns {Deferred} A promise that will resolve with an array of the folder's activities.
		* 
		*/
		getFolderActivities,
		/**
		* @ngdoc method
		* @name sbFolderDetailService#getFileCount
		* @methodOf sharebase.sbFolderDetailService
		* @kind function
		*
		* @description
		* Retrieves a specific folder's file count.
		* 
		* @param {object} folder A folder resource.
		*
		* @returns {Deferred} A promise that will resolve with the folder's file count.
		* 
		*/
		getFileCount
	};

	function getFolderDetails(folder) {
		return getFileCount(folder)
			.then(function (fileCount) {
				var results = {
					dateCreated: folder.DateCreated,
					dateModified: folder.DateModified,
					owner: folder.Owner,
					totalFiles: parseInt(fileCount)
				};
				
				return results;
			});
	}

	function getFolderActivities(folder) {
		return $http.get(folder.Links.ActivitiesUri + '?top=1000').then(function (response) {
			return response.data;
		});
	}

	function getFolderShares(folder) {
		return $http.get(folder.Links.SharesUri).then(function (response) {
			return response.data;
		});
	}

	function getFileCount(folder) {
		return sbFolderService.getDocuments(folder).then(function (docs) {
			return docs.length;
		});
	}
}

FolderDetailServiceFactory.$inject = [
	'$http',
	'$q',
	'settingsService',
	'sbFolderService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/folderDetailService.ts